export const MODE = {
  'ONE': 'ONE',
  'TWO': 'TWO',
  'THREE': 'THREE',
  'FOUR': 'FOUR'
}

export const DISPLAY = {
  HORIZONTAL: 'HORIZONTAL',
  VERTICAL: 'VERTICAL'
}